import Vue from 'vue'
import store from './../store'
import Storage from '@/utils/storage'
/**功能权限控制  自定义指令 */
const roleDirective = Vue.directive('role', {
    bind: (el, binding, vnode) => {
        // let menus = JSON.parse(Storage.getItem('role_power'))
        let menus = JSON.parse(localStorage.getItem('role_power'))
        const hasPermission = userPermission => {
            let userPermissionList = Array.isArray(userPermission) ? userPermission : userPermission;
            if(menus && menus.includes(userPermissionList)) {
                return menus.includes(userPermissionList)
            } else {
                return false
            }
        };
        if (!hasPermission(binding.value)) {
        //   el.parentNode.removeChild(el);
          el.style.display="none"
        }
    },
    inserted: function (el, binding, vnode) {
        // let RoleName = JSON.parse(Storage.getItem('role_power'))
        let RoleName = JSON.parse(localStorage.getItem('role_power'))
        // let RoleName =  Storage.getItem('roleName')
        // let user = Storage.getItem('admin_user')
        // user = JSON.parse(user)
        const hasPermission = userPermission => {
            let userPermissionList = Array.isArray(userPermission) ? userPermission : userPermission;
            if(RoleName && RoleName.includes(userPermissionList)) {
                return RoleName.includes(userPermissionList)
            } else {
                return false
            }
        };
        if (!hasPermission(binding.value)) {
        //   el.parentNode.removeChild(el);
          el.style.display="none"
        }
    },
    update: function (el, binding, vnode) {
        // let RoleName =  JSON.parse(Storage.getItem('role_power'))
        let RoleName =  JSON.parse(localStorage.getItem('role_power'))
        // let user = Storage.getItem('admin_user')
        // user = JSON.parse(user)
        const hasPermission = userPermission => {
            let userPermissionList = Array.isArray(userPermission) ? userPermission : userPermission;
            if(RoleName && RoleName.includes(userPermissionList)) {
                return RoleName.includes(userPermissionList)
            } else {
                return false
            }
        };
        if (!hasPermission(binding.value)) {
        //   el.parentNode.removeChild(el);
          el.style.display="none"
        }
    },
    componentUpdated: function (el, binding, vnode) {
    },
    unbind: function (el, binding, vnode) {
    }
});

export { roleDirective } 


// WEBPACK FOOTER //
// ./src/directive/roleDirective.js